export default __webpack_public_path__ + "static/media/25.98024b18.png";